import { useTheme, setTheme, type ThemePreference } from "@/lib/theme";

const OPTIONS: { id: ThemePreference; label: string; glyph: string }[] = [
  { id: "light", label: "Light", glyph: "☀" },
  { id: "dark", label: "Dark", glyph: "☾" },
  { id: "system", label: "System", glyph: "⌘" },
];

/**
 * Three-way light / dark / system control. The preference persists and is
 * applied with no flash via the inline script in __root (see src/lib/theme.ts).
 */
export function ThemeToggle() {
  const pref = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Color theme"
      className="inline-flex rounded-lg border border-border bg-surface/60 p-0.5"
    >
      {OPTIONS.map((opt) => {
        const active = pref === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={opt.label}
            title={`${opt.label} theme`}
            onClick={() => setTheme(opt.id)}
            className={`rounded-md px-2 py-1 text-sm transition-colors ${
              active
                ? "bg-secondary text-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <span aria-hidden="true">{opt.glyph}</span>
          </button>
        );
      })}
    </div>
  );
}
